import manino from "../../assets/icons/logo1.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const SuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div
      className="end-page_wrapper form-item mt-100"
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "32px",
      }}
    >
      <img
        src={manino}
        alt="logo"
        style={{
          maxWidth: "180px",
          height: "120px",
          marginBottom: "16px",
          display: "block",
        }}
      />
      <h1
        style={{ marginBottom: "16px", textAlign: "center", maxWidth: "600px" }}
      >
        {t("Quote.endPage.resTitle")}
      </h1>

      <button
        onClick={() => navigate("/")}
        type="button"
        className="services-type_btn"
        style={{
          marginTop: "16px",
          padding: "12px 32px",
          fontSize: "18px",
          borderRadius: "8px",
          background: "#06ae5a",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
      >
        {t("Quote.endPage.btnToHome")}
      </button>
    </div>
  );
};

export default SuccessPage;
